<dx-drawer
  [openedStateMode]="selectedOpenMode"
  [position]="selectedPosition"
  [revealMode]="selectedRevealMode"
  template="template"
  [(opened)]="isDrawerOpen"
  [height]="400"
  [closeOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'template'" style="width: 200px">
    <dx-list
      class="panel-list dx-theme-accent-as-background-color"
      [dataSource]="navigation"
      [hoverStateEnabled]="false"
      [activeStateEnabled]="false"
      [focusStateEnabled]="false"
    >
    </dx-list>
  </div>
  <div id="content" class="dx-theme-background-color" [innerHTML]="text"></div>
</dx-drawer>
